import {
  Box,
  Card,
  Typography,
  Container,
  Divider
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { styled } from '@mui/material/styles';
import Footer from 'src/components/Footer';

const MainContent = styled(Box)(
  ({ theme }) => `
    height: 100%;
    display: flex;
    flex: 1;
    overflow: auto;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: ${theme.spacing(4)} 0;
`
);

function Disclaimer() {
  return (
    <>
      <Helmet>
        <title>Disclaimer - Portfoliomatic</title>
      </Helmet>
      <MainContent>
        <Container maxWidth="md">
          <Card sx={{ p: 4 }}>
            <Typography variant="h3" component="h1" gutterBottom>
              Disclaimer
            </Typography>
            <Divider sx={{ mb: 3 }} />
            
            <Typography variant="body1" paragraph>
              Portfoliomatic is an educational tool designed to help users explore investment strategies and simulate portfolio management. We do not provide financial, legal, or tax advice.
            </Typography>

            <Typography variant="body1" paragraph>
              All trade suggestions or strategy outputs are generated algorithmically based on user-provided configurations. Portfoliomatic does not consider your personal financial situation, objectives, or needs, and we are not licensed financial advisors.
            </Typography>

            <Typography variant="body1" paragraph>
              Trade suggestions are not investment recommendations. You are solely responsible for evaluating the information on this site and for any decisions you make. Portfoliomatic does not execute trades, manage funds, or provide personalized advice.
            </Typography>

            <Typography variant="body1" paragraph>
              We make no guarantees regarding the performance of any strategy, including historical data modeling. Past results are not indicative of future performance.
            </Typography>

            <Typography variant="body1" paragraph sx={{ fontWeight: 'bold' }}>
              Always consult a licensed financial advisor before making investment decisions.
            </Typography>

            <Typography variant="body1" paragraph>
              When an exchange rate is unavailable for a specific valuation date, Portfoliomatic uses the nearest prior available FX rate to convert values. As a result, converted totals may not reflect the exact exchange rate for that date.
            </Typography>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h5" component="h2" gutterBottom>
              Educational Purpose Only
            </Typography>
            
            <Typography variant="body1" paragraph>
              All content, tools, and features provided by Portfoliomatic are intended for educational and informational purposes only. This platform is designed to help users learn about investment strategies and portfolio management concepts through simulation and analysis.
            </Typography>

            <Typography variant="h5" component="h2" gutterBottom>
              No Warranty
            </Typography>
            
            <Typography variant="body1" paragraph>
              We do not warrant the accuracy, completeness, or usefulness of any information provided through this platform. Your use of Portfoliomatic is at your own risk, and we are not liable for any loss or damage resulting from the use of this site or acting upon any information or suggestions provided.
            </Typography>
          </Card>
        </Container>
      </MainContent>
      <Footer />
    </>
  );
}

export default Disclaimer;